import API from "..";
import { checkAPIResponse } from "../helpers";

export default class FilterCriteria {
  constructor({
    id,
    filterName,
    filterModuleName,
    filterPayload,
    userEmail,
    isDefault,
  }) {
    this.id = id;
    this.filterName = filterName;
    this.filterModuleName = filterModuleName;
    this.filterPayload = filterPayload;
    this.userEmail = userEmail;
    this.isDefault = isDefault;
  }

  static async getByModule(module) {
    const api = await API();
    const response = await api.get(`/filterCriteria?module=${module}`);
    checkAPIResponse(response);

    const result = response?.data?.result; 

    if(!Array.isArray(result)) return [];

    return result?.map((d) => new FilterCriteria(d));
  }

  static async create(filterCriteria) {
    const api = await API();
    const response = await api.post(`/filterCriteria`, filterCriteria);
    checkAPIResponse(response);
    return response.data.result;
  }

  static async update(filterCriteria) {
    const api = await API();
    const response = await api.put(`/filterCriteria/`, filterCriteria);
    checkAPIResponse(response);
    return response.data.result;
  }

  static async delete(id) {
    const api = await API();
    const { data } = await api.delete(`/filterCriteria/${id}`);
    return data;
  }
}